import React from 'react';
import { Zap } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const Logo: React.FC<{ size?: 'sm' | 'md' | 'lg' }> = ({ size = 'md' }) => {
  const { t } = useLanguage();
  const containerSize = size === 'sm' ? 'w-8 h-8' : size === 'md' ? 'w-10 h-10' : 'w-12 h-12';
  const iconSize = size === 'sm' ? 16 : size === 'md' ? 24 : 32;
  const textSize = size === 'sm' ? 'text-lg' : size === 'md' ? 'text-2xl' : 'text-3xl';

  return (
    <div className="flex items-center gap-2.5">
      <div className={`${containerSize} bg-primary rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/20`}>
        <Zap size={iconSize} className="text-white fill-current" />
      </div>
      <span className={`${textSize} font-bold tracking-tight text-slate-900`}>
        {t('appName')}
      </span>
    </div>
  );
};
